module.exports = __webpack_public_path__ + "a2a41220f091a722305b6c9f7d6116ec.svg";